import React from 'react';

import {
    Modal, ModalHeader, ModalBody, ModalFooter,
    Button, Input
} from 'reactstrap';


import Isvg from 'react-inlinesvg';

import infoIcon from "../../../assets/svg/link-new-tab.svg";
import ScheduleAdministrativeBooking from './scheduleAdministrativeBooking';
import moment from 'moment';
import PatientModal from '../scheduleEventHelper/patientModal';

class AddNewAdministrativeBookingButton extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            hasPermission: false,
            scheduleButtonClicked: false,
        }
    }

    checkPermissions = () => {
        const groupData = this.getGroupData();
        const administrativeBookingsAllowed = groupData?.administrativeBookingsAllowed || true ? true : false;
        if (administrativeBookingsAllowed !== this.state.hasPermission) {
            this.setState({ hasPermission: administrativeBookingsAllowed });
        }
    }

    componentDidMount() {
        this.checkPermissions();
    }

    getGroupData = () => {
        let selectedGroupIdx = -1;
        if (this.props.uData && this.props.selectedGroup && this.props.uData?.clinicGroups?.length) {
            for (let i = 0; i < this.props.uData.clinicGroups.length; i++) {
                if (this.props.uData.clinicGroups[i]._id == this.props.selectedGroup) {
                    selectedGroupIdx = i;
                    break;
                }
            }
        }

        const groupData = selectedGroupIdx > -1 ? this.props.uData?.clinicGroups?.[selectedGroupIdx] : null;
        return groupData;
    }

    generateInitialTime = () => {
        const initialData = this.props.initialData;
        if (Object.keys(initialData).length) {
            const { date, startTime, endTime, title } = initialData;
            if (date && startTime && endTime) {
                let data = {
                    date,
                    endDate: date,
                    startTime,
                    endTime,
                    title: title || ''
                }
                if (this.props.doctorId) {
                    data.doctorId = this.props.doctorId;
                }
                return data;
            }
        }
        let tsNow = Math.floor(new Date().getTime() / 1000);
        const interval = 10 * 60;
        const ts = Math.ceil(tsNow / interval) * interval;

        let date = moment.unix(ts).format(this.props.dateFormat);
        let startTime = moment.unix(ts).format('HH:mm');
        let endTime = moment.unix(ts + 60 * 5).format('HH:mm');

        let data = {
            date,
            endDate: date,
            startTime,
            endTime,
            title: ''
        }
        if (this.props.doctorId) {
            data.doctorId = this.props.doctorId;
        }

        return data;
    }

    scheduleNewAdministrativeBooking = () => {
        if (this.state.scheduleButtonClicked) return;
        const initialTime = this.generateInitialTime();
        let setObj = { scheduleButtonClicked: true };
        setObj.scheduleAdministrativeBookingModal = { ...initialTime };

        if (this.props.preselectPatient) {
            setObj.scheduleAdministrativeBookingModal = { ...initialTime, patientData: { ...this.props.preselectPatient } };
        }

        this.setState(setObj);
    };

    toggle = () => {
        if (this.props.toggle) {
            this.props.toggle();
        }
    }


    render() {
        if (!this.state.hasPermission) {
            return null;
        }

        return (
            <>
                <Button
                    color='primary'
                    onClick={() => this.scheduleNewAdministrativeBooking()}
                >
                    {/* {'Schedule a new administrative booking'.translate(this.props.lang)} */}
                    {'Administrative booking'.translate(this.props.lang)}
                </Button>

                {
                    this.state.scheduleAdministrativeBookingModal ?
                        <ScheduleAdministrativeBooking
                            {...this.props}
                            isOpen={this.state.scheduleAdministrativeBookingModal}
                            preselectPatient={this.props.preselectPatient}
                            toggle={(toggle = false) => this.setState({ scheduleAdministrativeBookingModal: null }, () => {
                                if (toggle) {
                                    this.toggle();
                                }
                            })}
                            findPatient={(data, callback) => {
                                this.setState({ patientModal: data, scheduleAdministrativeBookingModal: null }, () => {

                                    if (callback) {
                                        callback();
                                    }
                                })
                            }}
                        />
                        :
                        null
                }
                {
                    this.state.patientModal ?
                        <PatientModal
                            {...this.props}
                            isOpen={this.state.patientModal}
                            toggle={(notToggle = false) => this.setState({ patientModal: false }, () => {
                                if (!notToggle) {
                                    this.toggle(true);
                                }
                            })}
                            setData={(data, callback) => {
                                console.log('patient data', data);
                                if (data?.patient) {
                                    this.setState({ scheduleAdministrativeBookingModal: { ...data } }, () => {
                                        if (callback) {
                                            callback?.();
                                        }
                                    })
                                }
                            }}
                        />
                        :
                        null
                }
            </>
        )

    }
}

export default AddNewAdministrativeBookingButton;